<script>
/* eslint max-len:0 */
import amapApp from '@ali/amap-lib';
import service from '../js/service';
/*
     * 父组件需传入 title_data
     *   title_data:{
     *       title:'titlebar标题'
     *       bg:'#fff' //titlebar 背景颜色 不传默认为#fff
     *       color:'#000' //titlebar 背景颜色 不传默认为#000
     *   }
     * */
export default {
  props: ['title_data'],
  data() {
    return {
    };
  },
  created() {
    service.isImmersion().then((height) => {
      document.getElementById('titlebar').style.paddingTop = `${height}px`;
    });
  },
  watch: {
  },
  methods: {
    go_back() {
      amapApp.native.webviewGoBack();
    },
  },
};
</script>
<template>
    <section id="titlebar" class="titlebar" :title="title_data&&title_data.title" :style="{color:title_data&&title_data.color, backgroundColor: title_data&&title_data.backgroundColor}">
        <span class="back btn" @click="go_back"></span>
    </section>
</template>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import "../css/common-mixin";
    .ios .titlebar{
        padding-top: rpx(40);
    }
    /* iPhoneX  XS XR XSMas适配 */
    @media only screen and (device-width: 375px) and (device-height: 812px)
    and (-webkit-device-pixel-ratio: 3),
    only screen and (device-width: 414px) and (device-height: 896px)
    and (-webkit-device-pixel-ratio: 2),
    only screen and (device-width: 414px) and (device-height: 896px)
    and (-webkit-device-pixel-ratio: 3){
        .ios .titlebar{
            padding-top:rpx(88);
        }
    }

    .titlebar{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        width: 100vw;
        height: rpx(96);
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        z-index: 99;
        color: #000;
        background: #fbfbfb;
        text-align: center;
        box-shadow: 0 1px 0 rgba(204,204,204,.5);
        &:before{
            content: attr(title);
            height: 100%;
            line-height: rpx(96);
            font-size: rpx(36);
            color: #000;
            /*font-weight: bold;*/
        }
        .btn{
            position: absolute;
            bottom: 0;
            width: rpx(96);
            height: rpx(96);
            &.back{
                left: 0;
                background: url("../../assets/common/back.png") center center no-repeat;
                background-size: 100% 100%;
            }
        }
    }

</style>
